import React, { useContext, useReducer, useEffect, useState } from "react";
import {
  AppContext,
  ProductsContext,
} from "../../../utils/stateHandlers/contexts";
import states from "../../../utils/stateHandlers/initialStates";
import formatting from "../../../utils/formatHelpers";
import { productReducer } from "../../../utils/stateHandlers/reducers";
import { Default, Mobile } from "../../../utils/deviceHelpers";
import { Link as DomLink } from "react-router-dom";
import { storage } from "../../../utils";
import api from "../../../utils/api";
import toast from "react-hot-toast";
import qs from "qs";
import DetailTable from "../components/DetailTable";
import { functions, constants } from "../../../utils";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import Material from "../components/productFields/Material";
import Dimension from "../components/productFields/Dimension";
import Quantity from "../components/productFields/Quantity";
import TreatmentField from "../components/TreatmentField";
import SpecialInstructions from "../components/SpecialInstructions";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import _ from "lodash";
import SolderImage from "../../../assets/images/SOLDER_GENERIC_XLG.png";
import ProductGalleryViewer from "../components/ProductGalleryViewer";
import TechnicalArticles from "../components/TechnicalArticles";
import CustomerTestimonials from "../components/CustomerTestimonials";
import HorizontalScrollList from "../components/HorizontalScrollList";
import Price from "../components/Price";
import FillerImage from "../../../assets/images/Filler-Harmony-8-1-22.gif";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

export default function Groups(props) {
  const { authToken } = useContext(AppContext);
  const [productState, productDispatch] = useReducer(
    productReducer,
    states.initialProductState
  );
  const {
    pageLoaded,
    icons,
    productFields,
    productDetails,
    productTreatments,
    images,
    productInfo,
    relatedProducts,
    metalColumns,
    strapiChart,
    TopText,
    BottomText,
    ChartSizeSmall,
    advertisement,
  } = productState;
  const [styleLoaded, setStyleLoaded] = useState(false);
  const [formsLoaded, setFormsLoaded] = useState(false);
  const [groupForm, setGroupForm] = useState(null);
  const [groupForms, setGroupForms] = useState();
  const [groupMetal, setGroupMetal] = useState(null);
  const [groupMetals, setGroupMetals] = useState();
  const groupName = props.match.params.GroupName;
  const frontImageUrl = constants.CMS_FRONT_IMAGE_URL;
  const productGroup = "";
  const RecentlyViewed = JSON.parse(
    storage.getSessionStorageItem("hsRecentlyViewedProducts")
  );

  function getGroupInformation() {
    productDispatch({ type: "setValidationErrors", payload: [] });
    api.fetch(`quickorder/group?style=${groupName}`).then((response) => {
      if (response.isAxiosError) {
        const errorMessage = [];
        _.forEach(response.response.data.errors, function (error) {
          errorMessage.push(error);
        });
        console.log(errorMessage);
        toast.error(
          `There was an error processing your request. ${_.toString(
            errorMessage
          )}`
        );
      } else {
        const metalField = _.find(response.data.fields, function (field) {
          return field.name === "metal";
        });
        setGroupMetals(metalField.values);
        productDispatch({ type: "setPageLoaded", payload: true });
      }
    });
  }

  function makeInitialQueryString(productDefaults) {
    const query = qs.stringify({
      style: groupName,
      metal: groupMetal,
      form: groupForm,
      product: productDefaults.product,
      dimension:
        groupMetal === "Flux" && groupForm === "FIRESCOFF"
          ? "FIRESCOFF"
          : productDefaults.dimension,
      quantity: productDefaults.quantity,
      quantity_unit: productDefaults.quantity_unit,
      material: groupMetal === "Flux" ? "MS" : productDefaults.material,
      carat_size: productDefaults.carat_size,
      message: productDefaults.message,
      finger_size: productDefaults.finger_size,
      treatments: "",
    });
    return query;
  }

  function getInitialPrice(productDefaults) {
    const query = makeInitialQueryString(productDefaults);
    api.fetch(`quickorder/price?${query}`).then((response) => {
      if (response.isAxiosError) {
        const errorMessage = [];
        _.forEach(response.response.data.errors, function (error) {
          errorMessage.push(error);
        });
        console.log(errorMessage);
        toast.error(
          `There was an error processing your request. ${_.toString(
            errorMessage
          )}`
        );
        productDispatch({
          type: "setMessage",
          payload: {
            message: _.values(response.response.data.errors),
            type: "error",
          },
        });
        productDispatch({ type: "setPriceLoaded", payload: true });
      } else {
        productDispatch({
          type: "setMessage",
          payload: { message: null, type: null },
        });
        productDispatch({
          type: "setPrice",
          payload: _.update(response.data, "images", images),
        });
        productDispatch({ type: "setPriceLoaded", payload: true });
        getStrapiInfo();
        setStyleLoaded(true);
      }
    });
  }

  function createProductDefaults(product) {
    setStyleLoaded(false);
    var productDefaults = {};
    productDefaults = {
      ...productDefaults,
      product: product.product,
      description: product.description,
      treatments: "",
    };
    productDispatch({
      type: "setStyle",
      payload: product,
    });
    productDispatch({
      type: "setProductDefaults",
      field: "product",
      payload: product.product,
    });
    productDispatch({
      type: "setProductDefaults",
      field: "description",
      payload: product.description,
    });
    productDispatch({
      type: "setProductDefaults",
      field: "treatments",
      payload: "",
    });
    if (groupMetal === "Flux") {
      productDefaults = {
        ...productDefaults,
        material: "MS",
        dimension: groupForm === "FIRESCOFF" ? "FIRESCOFF" : "",
      };
      productDispatch({
        type: "setProductDefaults",
        field: "material",
        payload: "MS",
      });
      productDispatch({
        type: "setProductDefaults",
        field: "dimension",
        payload: groupForm === "FIRESCOFF" ? "FIRESCOFF" : "",
      });
    }
    _.forEach(product.fields, function (field) {
      if (field.template === "field_with_units") {
        productDispatch({
          type: "setProductDefaults",
          field: field.name,
          payload: field.default === 0 ? 1 : field.default,
        });
        productDispatch({
          type: "setProductDefaults",
          field: `${field.name}_unit`,
          payload: field.default_unit,
        });
        productDefaults = {
          ...productDefaults,
          [field.name]: field.default,
          [`${field.name}_unit`]: field.default_unit,
        };
      } else {
        productDispatch({
          type: "setProductDefaults",
          field: field.name,
          payload: field.default,
        });
        productDefaults = {
          ...productDefaults,
          [field.name]: field.default,
        };
      }
    });
    if (authToken) {
      getInitialPrice(productDefaults);
    }
  }

  function setTreatmentsString() {
    const treatmentsList = _.map(productInfo.treatments, function (treatment) {
      return treatment.value;
    });
    return _.join(treatmentsList, " ");
  }

  function makeQueryString() {
    const infoToStringify = {
      style: groupName,
      metal: groupMetal,
      form: groupForm,
      product: productInfo.product,
      dimension:
        groupMetal === "Flux" && groupForm === "FIRESCOFF"
          ? "FIRESCOFF"
          : productInfo.dimension,
      quantity: productInfo.quantity,
      quantity_unit: productInfo.quantity_unit,
      material: groupMetal === "Flux" ? "MS" : productInfo.material,
      carat_size: productInfo.carat_size,
      message: productInfo.message,
      finger_size: productInfo.finger_size,
      treatments: setTreatmentsString(),
    };
    const arrayOfValues = _.values(infoToStringify);
    const searchingForNone = _.includes(arrayOfValues, "None");
    if (!searchingForNone) {
      const query = qs.stringify(infoToStringify);
      return query;
    } else {
      productDispatch({ type: "setPriceLoaded", payload: true });
      return false;
    }
  }

  function getUpdatedPrice(newQueryString) {
    api.fetch(`quickorder/price?${newQueryString}`).then((response) => {
      if (response.isAxiosError) {
        const errorMessage = [];
        _.forEach(response.response.data.errors, function (error) {
          errorMessage.push(error);
        });
        console.log(errorMessage);
        toast.error(
          `There was an error processing your request. ${_.toString(
            errorMessage
          )}`
        );
        productDispatch({
          type: "setMessage",
          payload: {
            message: _.values(response.response.data.errors),
            type: "error",
          },
        });
        productDispatch({ type: "setPriceLoaded", payload: true });
      } else {
        updateFields(response.data.fields);
        productDispatch({
          type: "setNewTreatmentFields",
          payload: response.data.treatments,
        });
        productDispatch({ type: "updatePrice", payload: response.data });
        productDispatch({
          type: "setMessage",
          payload: { message: null, type: null },
        });
        productDispatch({ type: "setPriceLoaded", payload: true });
      }
    });
  }

  function updateFields(fields) {
    const newFields = [];
    _.find(productFields, function (field) {
      newFields.push(field.name === "material" ? field : null);
    });
    _.forEach(fields, function (field) {
      newFields.push(
        field.name === "quantity"
          ? field
          : field.name === "dimension"
          ? field
          : null
      );
    });
    const filteredFields = _.uniq(_.without(newFields, null));
    const sortedFields = sortFields(filteredFields);
    productDispatch({
      type: "setNewFields",
      payload: sortedFields,
    });
  }

  function sortFields(fields) {
    const newSortedFields = [];
    _.forEach(fields, function (field) {
      const newField = _.assignIn(
        {
          SortOrder:
            field.name === "material"
              ? 1
              : field.name === "dimension"
              ? 2
              : 100,
        },
        field
      );
      newSortedFields.push(newField);
    });
    return _.sortBy(newSortedFields, "SortOrder");
  }

  function getStrapiInfo() {
    const strapiId = 2;
    const query = qs.stringify({
      populate: {
        left: {
          populate: "*",
        },
        middle: {
          populate: "*",
        },
        right: {
          populate: "*",
        },
        chart: {
          populate: "*",
        },
      },
    });
    api
      .fetchStrapi(`/product-details-charts/${strapiId}?${query}`)
      .then((response) => {
        productDispatch({
          type: "setStrapi",
          payload: {
            left: response.data.data.attributes.left,
            middle: response.data.data.attributes.middle,
            right: response.data.data.attributes.right,
            chart: response.data.data.attributes.chart,
            ChartSizeSmall: response.data.data.attributes.ChartSizeSmall,
            TopText: response.data.data.attributes.TopText,
            BottomText: response.data.data.attributes.BottomText,
          },
        });
      });
  }

  useEffect(() => {
    productDispatch({ type: "resetProductPage", payload: "" });
    getGroupInformation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.match.params.GroupName]);

  //advertisements from Strapi
  useEffect(() => {
    const query = qs.stringify({
      populate: {
        One: {
          populate: "*",
        },
        Two: {
          populate: "*",
        },
        Three: {
          populate: "*",
        },
        Four: {
          populate: "*",
        },
        Five: {
          populate: "*",
        },
      },
    });
    api.fetchStrapi(`/detail-page-ad?${query}`).then((response) => {
      const randomNum = Math.floor(Math.random() * 5);
      const randomAd =
        randomNum === 1
          ? response.data.data.attributes.One.data.attributes
          : randomNum === 2
          ? response.data.data.attributes.Two.data.attributes
          : randomNum === 3
          ? response.data.data.attributes.Three.data.attributes
          : randomNum === 4
          ? response.data.data.attributes.Four.data.attributes
          : response.data.data.attributes.Five.data.attributes;
      productDispatch({
        type: "setPageAd",
        payload: randomAd,
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.match.params.ProductStyleCode]);

  useEffect(() => {
    if (groupMetal !== "None" && groupMetal !== null) {
      productDispatch({ type: "setPriceLoaded", payload: false });
      productDispatch({ type: "resetProductPage", payload: "" });
      setFormsLoaded(false);
      setGroupForm(null);
      api
        .fetch(`quickorder/group?style=${groupName}&metal=${groupMetal}`)
        .then((response) => {
          if (response.isAxiosError) {
            const errorMessage = [];
            _.forEach(response.response.data.errors, function (error) {
              errorMessage.push(error);
            });
            console.log(errorMessage);
            toast.error(
              `There was an error processing your request. ${_.toString(
                errorMessage
              )}`
            );
          } else {
            productDispatch({
              type: "setMessage",
              payload: { message: null, type: null },
            });
            const formField = _.find(response.data.fields, function (field) {
              return field.name === "form";
            });
            setGroupForms(formField.values);
            setFormsLoaded(true);
          }
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupMetal]);

  useEffect(() => {
    if (groupForm !== "None" && groupForm !== null) {
      productDispatch({ type: "resetProductPage", payload: "" });
      productDispatch({ type: "setPriceLoaded", payload: false });
      api
        .fetch(
          `quickorder/group?style=${groupName}&metal=${groupMetal}&form=${groupForm}`
        )
        .then((response) => {
          if (response.isAxiosError) {
            const errorMessage = [];
            _.forEach(response.response.data.errors, function (error) {
              errorMessage.push(error);
            });
            console.log(errorMessage);
            toast.error(
              `There was an error processing your request. ${_.toString(
                errorMessage
              )}`
            );
          } else {
            createProductDefaults(response.data);
            functions.storeRecentlyViewed(response.data);
          }
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupForm]);

  //update price
  useEffect(() => {
    if (authToken && pageLoaded && styleLoaded && productInfo.quantity > 0) {
      productDispatch({ type: "setPriceLoaded", payload: false });
      const newQueryString = makeQueryString();
      newQueryString !== false && getUpdatedPrice(newQueryString);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productInfo]);

  return (
    <ProductsContext.Provider value={{ productState, productDispatch }}>
      {!pageLoaded ? (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={true}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      ) : (
        <Container maxWidth="xl">
          <Mobile>
            <Stack spacing={2}>
              <Stack spacing={1} className="center">
                <Typography variant="h4">{_.capitalize(groupName)}</Typography>

                <Typography>
                  {productInfo.description &&
                    formatting["decodeHtml"](productInfo.description)}
                </Typography>
                <Stack direction="row" spacing={1}>
                  {groupMetal &&
                    groupForm &&
                    icons &&
                    icons.map((icons, key) => (
                      <Typography key={icons} className="icons">
                        {functions.getIcons(icons)}
                      </Typography>
                    ))}
                </Stack>
              </Stack>
              <Divider flexItem />
              {groupMetal && groupForm ? (
                <ProductGalleryViewer images={images} />
              ) : (
                <img
                  src={SolderImage}
                  alt="Selected Product"
                  className="selected-product"
                />
              )}
              <Stack sx={{ width: "100%" }}>
                <Typography
                  sx={{
                    fontWeight: "700",
                    paddingBottom: ".3rem",
                  }}
                >
                  {`${_.capitalize(groupName)} Metal`}
                </Typography>
                <Select
                  value={groupMetal ? groupMetal : "None"}
                  size="small"
                  sx={{ width: "100%" }}
                  onChange={(e) => {
                    setGroupMetal(e.target.value);
                  }}
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        border: "1px solid #939598",
                        borderRadius: "0",
                        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                      },
                    },
                  }}
                >
                  <MenuItem value="None">
                    <em>Select...</em>
                  </MenuItem>
                  {groupMetals &&
                    groupMetals.map((metal) => (
                      <MenuItem key={metal.value} value={metal.value}>
                        {metal.label}
                      </MenuItem>
                    ))}
                </Select>
              </Stack>
              {groupMetal && (
                <Stack sx={{ width: "100%" }}>
                  <Typography
                    sx={{ fontWeight: "700", paddingBottom: ".3rem" }}
                  >
                    {`${_.capitalize(groupName)} Form`}
                  </Typography>
                  <Select
                    value={groupForm ? groupForm : "None"}
                    size="small"
                    sx={{ width: "100%" }}
                    disabled={!formsLoaded}
                    onChange={(e) => {
                      setGroupForm(e.target.value);
                    }}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          border: "1px solid #939598",
                          borderRadius: "0",
                          maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                        },
                      },
                    }}
                  >
                    <MenuItem value="None">
                      <em>Select...</em>
                    </MenuItem>
                    {groupForms &&
                      groupForms.map((form) => (
                        <MenuItem key={form.value} value={form.value}>
                          {form.label}
                        </MenuItem>
                      ))}
                  </Select>
                </Stack>
              )}
              <Divider flexItem sx={{ paddingBottom: ".2rem" }} />
              <Stack spacing={2} sx={{ marginBottom: "8rem" }}>
                {groupMetal &&
                  groupForm &&
                  productFields &&
                  productFields.map((field) => {
                    if (field.name === "material") {
                      return (
                        <Material
                          field={field}
                          key={field.name}
                          isMill={props.isMill}
                        />
                      );
                    } else if (field.name === "dimension") {
                      return (
                        <Dimension
                          field={field}
                          key={field.name}
                          isMill={props.isMill}
                        />
                      );
                    } else if (field.name === "quantity") {
                      return (
                        <Quantity
                          field={field}
                          key={field.name}
                          isMill={props.isMill}
                        />
                      );
                    } else {
                      return "";
                    }
                  })}
                {groupMetal &&
                  groupForm &&
                  productTreatments &&
                  productTreatments.map((treat) => {
                    return <TreatmentField field={treat} key={treat.label} />;
                  })}
                {groupMetal && groupForm && <SpecialInstructions />}
                {groupMetal && groupForm && (
                  <Price ProductGroup={productGroup} isMill={true} />
                )}
                {groupMetal && groupForm && (
                  <DetailTable data={productDetails} />
                )}
                <Typography variant="h2" sx={{ marginTop: "2rem" }}>
                  Related Items
                </Typography>
                {relatedProducts && (
                  <HorizontalScrollList
                    loadedStyles={relatedProducts}
                    related={true}
                  />
                )}
                {strapiChart && (
                  <>
                    <Typography variant="h2" sx={{ marginTop: "2rem" }}>
                      Product Series
                    </Typography>
                    <img
                      src={`${frontImageUrl}${strapiChart.data.attributes.url}`}
                      width="100%"
                      alt="banner"
                    />
                  </>
                )}
                <TechnicalArticles />
                <CustomerTestimonials />
                <Typography variant="h2" sx={{ marginTop: "2rem" }}>
                  Recently Viewed
                </Typography>
                {RecentlyViewed && (
                  <HorizontalScrollList loadedStyles={RecentlyViewed} />
                )}
              </Stack>
            </Stack>
          </Mobile>
          <Default>
            <Grid container spacing={6} sx={{ marginBottom: "1rem" }}>
              <Grid item xs={5} sx={{ borderRight: "2px solid #e3e3e3" }}>
                <Stack>
                  {groupMetal && groupForm ? (
                    <ProductGalleryViewer images={images} />
                  ) : (
                    <img
                      src={SolderImage}
                      alt="Selected Product"
                      className="selected-product"
                    />
                  )}
                  {groupMetal && groupForm && (
                    <DetailTable data={productDetails} />
                  )}
                </Stack>
              </Grid>
              <Grid item xs={4}>
                <Stack spacing={1} sx={{ marginBottom: ".5rem" }}>
                  <Typography variant="h4">
                    {_.capitalize(groupName)}
                  </Typography>
                  <Typography>
                    Select a metal to start placing your order!
                  </Typography>
                  <Stack direction="row" spacing={1}>
                    {groupMetal &&
                      groupForm &&
                      icons &&
                      icons.map((icons, key) => (
                        <Typography key={icons} className="icons">
                          {functions.getIcons(icons)}
                        </Typography>
                      ))}
                  </Stack>
                </Stack>
                <Stack spacing={1}>
                  <Stack>
                    <Typography
                      sx={{
                        fontWeight: "700",
                        paddingBottom: ".3rem",
                      }}
                    >
                      {`${_.capitalize(groupName)} Metal`}
                    </Typography>
                    <Select
                      value={groupMetal ? groupMetal : "None"}
                      size="small"
                      sx={{ width: "100%" }}
                      onChange={(e) => {
                        setGroupMetal(e.target.value);
                      }}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            border: "1px solid #939598",
                            borderRadius: "0",
                            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                          },
                        },
                      }}
                    >
                      <MenuItem value="None">
                        <em>Select...</em>
                      </MenuItem>
                      {groupMetals &&
                        groupMetals.map((metal) => (
                          <MenuItem key={metal.value} value={metal.value}>
                            {metal.label}
                          </MenuItem>
                        ))}
                    </Select>
                  </Stack>
                  {groupMetal && (
                    <Stack>
                      <Typography
                        sx={{ fontWeight: "700", paddingBottom: ".3rem" }}
                      >
                        {`${_.capitalize(groupName)} Form`}
                      </Typography>
                      <Select
                        value={groupForm ? groupForm : "None"}
                        size="small"
                        sx={{ width: "100%" }}
                        disabled={!formsLoaded}
                        onChange={(e) => {
                          setGroupForm(e.target.value);
                        }}
                        MenuProps={{
                          PaperProps: {
                            sx: {
                              border: "1px solid #939598",
                              borderRadius: "0",
                              maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                            },
                          },
                        }}
                      >
                        <MenuItem value="None">
                          <em>Select...</em>
                        </MenuItem>
                        {groupForms &&
                          groupForms.map((form) => (
                            <MenuItem key={form.value} value={form.value}>
                              {form.label}
                            </MenuItem>
                          ))}
                      </Select>
                    </Stack>
                  )}
                  {groupMetal && groupForm && productFields && (
                    <Divider flexItem sx={{ paddingTop: "1rem" }} />
                  )}
                  {groupMetal &&
                    groupForm &&
                    productFields &&
                    productFields.map((field) => {
                      if (field.name === "material" && groupMetal !== "Flux") {
                        return (
                          <Material
                            field={field}
                            key={field.name}
                            isMill={props.isMill}
                          />
                        );
                      } else if (
                        field.name === "dimension" &&
                        groupMetal !== "Flux"
                      ) {
                        return (
                          <Dimension
                            field={field}
                            key={field.name}
                            isMill={props.isMill}
                          />
                        );
                      } else if (field.name === "quantity") {
                        return (
                          <Quantity
                            field={field}
                            key={field.name}
                            isMill={props.isMill}
                          />
                        );
                      } else {
                        return "";
                      }
                    })}
                  {groupMetal && groupForm && productFields && (
                    <Divider flexItem sx={{ paddingTop: "1rem" }} />
                  )}
                  {groupMetal &&
                    groupForm &&
                    productTreatments &&
                    productTreatments.map((treat) => {
                      return <TreatmentField field={treat} key={treat.label} />;
                    })}
                  {groupMetal && groupForm && productFields && (
                    <SpecialInstructions />
                  )}
                </Stack>
              </Grid>
              <Grid item xs={3}>
                {groupMetal && groupForm && (
                  <Price ProductGroup={productGroup} isMill={true} />
                )}
                {advertisement && (
                  <DomLink
                    to={{
                      pathname: `${advertisement.alternativeText}`,
                      state: {
                        recentlyViewed: JSON.parse(
                          storage.getSessionStorageItem(
                            "hsRecentlyViewedProducts"
                          )
                        ),
                      },
                    }}
                  >
                    <img
                      style={{ marginTop: "4rem" }}
                      src={`${frontImageUrl}${advertisement.url}`}
                      width="100%"
                      alt="advertisement"
                    />
                  </DomLink>
                )}
              </Grid>
            </Grid>
            {groupMetal && groupForm && (
              <>
                <Typography variant="h2" sx={{ marginTop: "2rem" }}>
                  Related Items
                </Typography>
                {relatedProducts && (
                  <HorizontalScrollList
                    loadedStyles={relatedProducts}
                    related={true}
                  />
                )}
                <div>
                  <TechnicalArticles productGroup={productGroup} />
                  <CustomerTestimonials />
                </div>
                <Typography variant="h2" sx={{ marginTop: "2rem" }}>
                  Recently Viewed
                </Typography>
                {RecentlyViewed && (
                  <HorizontalScrollList loadedStyles={RecentlyViewed} />
                )}
              </>
            )}
            {metalColumns && (
              <>
                <Divider flexItem />
                <Grid container justifyContent="center">
                  <Grid item xs={4}>
                    <Typography variant="staticText">
                      <ReactMarkdown remarkPlugins={[remarkGfm]}>
                        {metalColumns.left}
                      </ReactMarkdown>
                    </Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography variant="staticText">
                      <ReactMarkdown remarkPlugins={[remarkGfm]}>
                        {metalColumns.middle}
                      </ReactMarkdown>
                    </Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography variant="staticText">
                      <ReactMarkdown remarkPlugins={[remarkGfm]}>
                        {metalColumns.right}
                      </ReactMarkdown>
                    </Typography>
                  </Grid>
                </Grid>
              </>
            )}
            {strapiChart && (
              <>
                <Typography variant="h2" sx={{ marginTop: "2rem" }}>
                  Product Series
                </Typography>
                {TopText && (
                  <Typography variant="staticText">
                    <ReactMarkdown remarkPlugins={[remarkGfm]}>
                      {TopText}
                    </ReactMarkdown>
                  </Typography>
                )}
                {ChartSizeSmall ? (
                  <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Grid item xs={6} className="center">
                      <img
                        src={`${frontImageUrl}${strapiChart.data.attributes.url}`}
                        width="100%"
                        alt="banner"
                      />
                    </Grid>
                    <Grid item xs={6} className="center">
                      <img src={FillerImage} alt="filler for small table" />
                    </Grid>
                  </Grid>
                ) : (
                  <img
                    src={`${frontImageUrl}${strapiChart.data.attributes.url}`}
                    width="100%"
                    alt="banner"
                  />
                )}
                {BottomText && (
                  <Typography variant="staticText">
                    <ReactMarkdown remarkPlugins={[remarkGfm]}>
                      {BottomText}
                    </ReactMarkdown>
                  </Typography>
                )}
              </>
            )}
          </Default>
        </Container>
      )}
    </ProductsContext.Provider>
  );
}
